import * as React from 'react'

import {
  ParentUserNav,
  IProps as IParentUserNav,
} from '~/organisms/nav/ParentUserNav'

import * as Style from './style.css'

export interface IProps extends IParentUserNav {
  children: React.ReactNode
}

export const UserBaseLayout = ({
  user,
  pageType,
  ...props
}: IProps): JSX.Element => (
  <>
    <div className={Style.UserBaseLayoutNav}>
      <ParentUserNav user={user} pageType={pageType} />
    </div>
    <div className="yeild-main">{props.children}</div>
  </>
)
